import React from 'react'

export default function WebFlightPaxReport({
  data: {
    options: { data, dataset },
  },
}) {
  const { logoUrl } = data
  const {
    title,
    airlineName,
    airlineLogoURL,
    stationName,
    startDate,
    endDate,
    user_displayName,
    flights,
  } = dataset

  return (
    <div className="w-[840px] mx-auto py-6 px-6 bg-white print:bg-transparent shadow print:shadow-none">
      <div className="w-full py-2 px-1 flex flex-col space-y-4">
        <div className="flex flex-col w-full items-center justify-center p-4">
          <img
            className="object-contain w-32"
            src={airlineLogoURL || logoUrl}
            alt={airlineName}
          />
          <span className="text-2xl font-semibold text-center">{title}</span>
        </div>

        <div className="w-full flex space-x-4 justify-between">
          <span className="space-x-2">
            <span className="font-semibold uppercase">Airline:</span>
            <span>{airlineName || '-'}</span>
          </span>
          <span className="space-x-2">
            <span className="font-semibold uppercase">Station:</span>
            <span>{stationName || '-'}</span>
          </span>
          <span className="space-x-2">
            <span className="font-semibold uppercase">DATE:</span>
            <span>
              {startDate} - {endDate}
            </span>
          </span>
        </div>

        {flights && flights.length > 0 ? (
          flights.map((flight, index) => (
            <div
              key={flight.flightNumber}
              // Page-break AFTER each flight (except the last) so the next flight
              // starts fresh. Uses break-after-page (the only page-break utility
              // this project's Tailwind build ships). Do NOT add break-inside-avoid
              // here: a 31-row table can approach a full page, and forcing it to
              // stay whole shoves an otherwise-fitting table onto the next page,
              // leaving the previous page mostly blank.
              className={
                index !== flights.length - 1 ? 'break-after-page' : ''
              }
            >
              <table className="table table-fixed w-full text-base text-left text-stone-500 rounded-lg overflow-hidden mt-4">
                <thead className="text-base text-stone-700 uppercase bg-stone-100">
                  <tr>
                    <th className="px-3 py-2 text-left" colSpan={5}>
                      {flight.flightNumber}
                    </th>
                  </tr>
                  <tr>
                    <th className="px-3 py-2">Date</th>
                    <th className="px-3 py-2 w-[90px] text-center">Total</th>
                    <th className="px-3 py-2 w-[90px] text-center">Economy</th>
                    <th className="px-3 py-2 w-[90px] text-center">Business</th>
                    <th className="px-3 py-2 w-[90px] text-center">
                      First Class
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {flight.rows.map((row) => (
                    <tr
                      key={row.date}
                      className="odd:bg-white even:bg-stone-50 border-b print:break-inside-avoid"
                    >
                      <td className="px-3 py-2">{row.date}</td>
                      <td className="px-3 py-2 text-center">
                        {row.total ? row.total.toLocaleString() : '-'}
                      </td>
                      <td className="px-3 py-2 text-center">
                        {row.economy ? row.economy.toLocaleString() : '-'}
                      </td>
                      <td className="px-3 py-2 text-center">
                        {row.business ? row.business.toLocaleString() : '-'}
                      </td>
                      <td className="px-3 py-2 text-center">
                        {row.firstClass ? row.firstClass.toLocaleString() : '-'}
                      </td>
                    </tr>
                  ))}
                  {/* Totals live in tbody (not tfoot) so they print ONCE at the
                      end of the flight's section — a real <tfoot> repeats on
                      every printed page. */}
                  <tr className="text-stone-700 font-semibold uppercase bg-stone-100 print:break-inside-avoid">
                    <td className="px-3 py-2">TOTAL PAX {flight.flightNumber}</td>
                    <td className="px-3 py-2 text-center">
                      {flight.totals.total.toLocaleString()}
                    </td>
                    <td className="px-3 py-2 text-center">
                      {flight.totals.economy.toLocaleString()}
                    </td>
                    <td className="px-3 py-2 text-center">
                      {flight.totals.business.toLocaleString()}
                    </td>
                    <td className="px-3 py-2 text-center">
                      {flight.totals.firstClass.toLocaleString()}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          ))
        ) : (
          <div className="p-10 w-full text-center text-2xl font-semibold">
            No Results
          </div>
        )}

        <div className="w-full flex mt-6 justify-between">
          <span className="font-semibold flex-1 space-x-2">
            <span>REPORTED BY:</span>
            <span>{user_displayName}</span>
          </span>
          <span className="font-semibold space-x-2">CERTIFIED BY:</span>
          <span>......................................</span>
        </div>
      </div>
    </div>
  )
}
